import Route from 'cio/routes/base';

export default class IntegrationsTypesRoute extends Route {
  crumb() {
    let { type } = this.paramsFor('integrations.data_out.type') as Record<string, string>;

    return {
      name: type
        ? type
            .replace(/_/g, ' ')
            .replace(/Out$/, '')
            .replace(/^./, (s) => s.toUpperCase())
        : '',
      path: 'integrations.data_out.type',
      model: type,
    };
  }
}
